<template>
  <div class="marker-symbol" :class="extraClass" :style="computedStyle">
    <span class="marker-text">{{ text }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  text: string;
  styleObj: Record<string, any>;
  extraClass?: string;
  markerVerticalOffset?: number;
}>();

const computedStyle = computed(() => {
  const baseStyle = { ...props.styleObj };
  if (props.markerVerticalOffset !== undefined && props.markerVerticalOffset !== 0) {
    baseStyle.transform = `translateY(${props.markerVerticalOffset}px)`;
  }
  return baseStyle;
});
</script>

<style scoped>
.marker-symbol {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.marker-text {
  color: inherit;
  user-select: none;
}
</style>


